import { createFileRoute, Outlet } from '@tanstack/react-router'
import { LiffBootstrap } from '@/components/liff/LiffBootstrap'

export const Route = createFileRoute('/liff')({
  component: LiffLayout,
})

function LiffLayout() {
  return (
    <LiffBootstrap>
      <Outlet />
    </LiffBootstrap>
  )
}
